import {
    Button,
    Card,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    TextField,
} from "@mui/material";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import styled from "styled-components";
import { PrimaryButton } from "../../Layouts/ButtonsControlled";
import { FormHeading } from "../../Layouts/Heading";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { getAllState, resetState } from "../../Redux/StateSlice/stateSlice";
import { Box } from "@mui/system";
import { Add, Delete } from "@mui/icons-material";
import {
    DeleteStateAction,
    GetSingleVendor,
    resetVendors,
    UpdateVendorData,
} from "../../Redux/VendorSlice/VendorSlice";
import { useParams } from "react-router-dom";
import LoadingAnimation from "../../Components/LottieAnimation/LoadingAnimation";
import { DeleteModal } from "../../Components/Modal/Modals";

const EditVendor = () => {
    const dispatch = useDispatch();
    const { id } = useParams();
    const { vendor, isLoading, isSuccess, isError, errors, StateLoading } =
        useSelector((state) => state.vendors);
    const vendorVal = vendor?.data || [];

    const { states } = useSelector((state) => state.AllStates);

    // Delete Vendor State Confirmation
    const [data, setData] = useState({});
    const [open, setOpen] = useState(false);
    const [tableId, setTableId] = useState(null);
    const [index, setIndex] = useState(0);
    const [target, setTarget] = useState({});

    const handleOpen = async (data, target) => {
        await setData(data);
        await setOpen(true);
        await setTarget(target);
    };
    const handleClose = () => {
        setOpen(false);
        setData({});
    };
    const CallNotificationMethod = async () => {
        await toast.success(" State deleted success");
        await dispatch(resetVendors());
    };

    const DeleteRow = async () => {
        handleClose();
        handelDeleteForm(data.id);
        await dispatch(DeleteStateAction(data.id));
        await CallNotificationMethod();
        getVendor();
    };
    const handelDeleteState = async (data, e, index) => {
        await setIndex(index);
        if (data.id) {
            handleOpen(data, e, index);
        } else {
            handelDeleteForm(data.id);
        }
    };

    // State Vendors Counts Of Create
    const [stateVendorFormQuantity, setstateVendorFormQuantity] = useState([]);

    const handelAddNewState = () => {
        let data = stateVendorFormQuantity;
        data = [
            ...stateVendorFormQuantity,
            {
                email: "",
                address: "",
                phone: "",
                state_id: "",
            },
        ];
        setstateVendorFormQuantity(data);
    };

    const handelFormChange = (e, index) => {
        let data = [...stateVendorFormQuantity];
        data[index][e.target.name] = e.target.value;
        setstateVendorFormQuantity(data);
        console.log(stateVendorFormQuantity[index]);
    };
    const DeleteState = async (state_id) => {
        await dispatch(DeleteStateAction(state_id));
        await dispatch(resetVendors());
    };
    const handelDeleteForm = async (state_id) => {
        let data = [...stateVendorFormQuantity];
        data.splice(index, 1);
        setstateVendorFormQuantity(data);
        DeleteState(state_id);
    };
    const handelResetData = async () => {
        if (isSuccess) {
            toast.success("Vendor Updated successfully");
            getVendor();
        }
    };

    useEffect(() => {
        if (vendorVal) {
            formik.values.name = vendorVal.name;
            setstateVendorFormQuantity(vendorVal.state_vendor);
        }
    }, [vendorVal]);

    useEffect(() => {
        if (StateLoading) {
            toast.success("Vendor State Deleted Successfully");
        }
    }, [StateLoading]);


    const getVendor = async () => {
        await dispatch(GetSingleVendor(id));
        await dispatch(resetState());
    };

    const AllStates = states?.data?.states;
    const getStates = async () => {
        await dispatch(getAllState());
        await dispatch(resetState());
    };

    // get all states
    useEffect(() => {
        getVendor();
        getStates();
    }, []);

    const validationSchema = yup.object({});
    const formik = useFormik({
        initialValues: {
            name: "",
            // state_vendor: {},
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            await dispatch(
                UpdateVendorData({
                    id: id,
                    name: values.name,
                    state_vendor: stateVendorFormQuantity,
                })
            );
            await handelResetData();
            // await dispatch(resetVendors());
        },
    });

    useEffect(() => {
        if (isError) {
            if (errors) {
                Object.keys(errors).forEach((key) => {
                    let error = errors[key][0];
                    toast.error(error);
                });
            }
            const reset = async () => {
                await dispatch(resetVendors);
            };
            reset();
        }
    }, [dispatch, errors, isError]);

    return (
        <>
            {isLoading && <LoadingAnimation />}
            {!isLoading && (
                <FormContainer>
                    <FormHeading> Update Vendor </FormHeading>
                    <form onSubmit={formik.handleSubmit}>
                        <Grid container columns={12} spacing={3}>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="name"
                                    name="name"
                                    label="Name"
                                    value={formik.values.name}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.name &&
                                        Boolean(formik.errors.name)
                                    }
                                    helperText={
                                        formik.touched.name &&
                                        formik.errors.name
                                    }
                                />
                            </Grid>
                            <Grid item mb={1} xs={12} md={12}>
                                <FormHeading> Vendor States </FormHeading>
                                {stateVendorFormQuantity?.map(
                                    (state, index) => {
                                        return (
                                            <Card
                                                key={index}
                                                variant="outlined"
                                                mb={2}
                                                style={{ padding: "10px" }}
                                            >
                                                <Box>
                                                    <Grid
                                                        mt={2}
                                                        container
                                                        columns={12}
                                                        spacing={3}
                                                    >
                                                        <Grid
                                                            item
                                                            mb={1}
                                                            xs={12}
                                                            md={10}
                                                        >
                                                            <Grid
                                                                container
                                                                columns={12}
                                                                spacing={3}
                                                            >
                                                                <Grid
                                                                    item
                                                                    mb={1}
                                                                    xs={12}
                                                                    md={6}
                                                                >
                                                                    <TextField
                                                                        fullWidth
                                                                        id="email"
                                                                        name="email"
                                                                        type="email"
                                                                        label="Email"
                                                                        disabled={
                                                                            state.id
                                                                                ? true
                                                                                : false
                                                                        }
                                                                        value={
                                                                            state.email
                                                                        }
                                                                        onChange={(
                                                                            e
                                                                        ) =>
                                                                            handelFormChange(
                                                                                e,
                                                                                index
                                                                            )
                                                                        }
                                                                    />
                                                                </Grid>

                                                                <Grid
                                                                    item
                                                                    mb={1}
                                                                    xs={12}
                                                                    md={6}
                                                                >
                                                                    <TextField
                                                                        fullWidth
                                                                        id="phone"
                                                                        name="phone"
                                                                        type="phone"
                                                                        label="Phone"
                                                                        disabled={
                                                                            state.id
                                                                                ? true
                                                                                : false
                                                                        }
                                                                        value={
                                                                            state.phone
                                                                        }
                                                                        onChange={(
                                                                            e
                                                                        ) =>
                                                                            handelFormChange(
                                                                                e,
                                                                                index
                                                                            )
                                                                        }
                                                                    />
                                                                </Grid>

                                                                <Grid
                                                                    item
                                                                    mb={1}
                                                                    xs={12}
                                                                    md={6}
                                                                >
                                                                    <TextField
                                                                        fullWidth
                                                                        id="address"
                                                                        name="address"
                                                                        type="address"
                                                                        label="Address"
                                                                        disabled={
                                                                            state.id
                                                                                ? true
                                                                                : false
                                                                        }
                                                                        value={
                                                                            state.address
                                                                        }
                                                                        onChange={(
                                                                            e
                                                                        ) =>
                                                                            handelFormChange(
                                                                                e,
                                                                                index
                                                                            )
                                                                        }
                                                                    />
                                                                </Grid>

                                                                <Grid
                                                                    item
                                                                    mb={1}
                                                                    xs={12}
                                                                    md={6}
                                                                >
                                                                    <FormControl
                                                                        fullWidth
                                                                        required={
                                                                            true
                                                                        }
                                                                    >
                                                                        <InputLabel id="demo-simple-select-label">
                                                                            State
                                                                        </InputLabel>
                                                                        <Select
                                                                            id="state_id"
                                                                            name="state_id"
                                                                            label="State"
                                                                            required
                                                                            disabled={
                                                                                state.id
                                                                                    ? true
                                                                                    : false
                                                                            }
                                                                            value={
                                                                                state.state_id
                                                                            }
                                                                            onChange={(
                                                                                e
                                                                            ) =>
                                                                                handelFormChange(
                                                                                    e,
                                                                                    index
                                                                                )
                                                                            }
                                                                        >
                                                                            {AllStates?.map(
                                                                                (
                                                                                    key
                                                                                ) => (
                                                                                    <MenuItem
                                                                                        key={
                                                                                            key.id
                                                                                        }
                                                                                        value={
                                                                                            key.id
                                                                                        }
                                                                                    >
                                                                                        {
                                                                                            key.name
                                                                                        }
                                                                                    </MenuItem>
                                                                                )
                                                                            )}
                                                                        </Select>
                                                                    </FormControl>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                        <Grid
                                                            item
                                                            mb={1}
                                                            xs={12}
                                                            md={2}
                                                            sx={{
                                                                alignItems:
                                                                    "center",
                                                            }}
                                                        >
                                                            <Button
                                                                variant="contained"
                                                                fullWidth
                                                                disableElevation
                                                                color="error"
                                                                sx={{
                                                                    alignItems:
                                                                        "center",
                                                                }}
                                                                onClick={(e) =>
                                                                    handelDeleteState(
                                                                        state,
                                                                        e,
                                                                        index,
                                                                        state.id
                                                                    )
                                                                }
                                                            >
                                                                <Delete />
                                                                Delete
                                                            </Button>
                                                        </Grid>
                                                    </Grid>
                                                </Box>
                                            </Card>
                                        );
                                    }
                                )}
                            </Grid>
                        </Grid>
                        <Grid container columns={12} spacing={3}>
                            <Grid item mb={1}>
                                <Button
                                    onClick={() => {
                                        handelAddNewState();
                                    }}
                                    variant="contained"
                                    color="success"
                                >
                                    <Add></Add>
                                    Add New State
                                </Button>
                            </Grid>
                        </Grid>
                        <PrimaryButton fullWidth type="submit">
                            {isLoading ? "loading ... " : " Update Vendor"}
                        </PrimaryButton>
                    </form>

                    <DeleteModal
                        open={open}
                        close={handleClose}
                        title={data?.state?.name}
                        onClick={DeleteRow}
                        loading={isLoading}
                    />
                </FormContainer>
            )}
        </>
    );
};

const FormContainer = styled.div`
    padding: 1rem;
`;
export default EditVendor;
